import { CFBaseProgressTokens } from '.';
export const itemColor = ({ alternateTheme = false, disabled = false, isCurrent = false, variant = 'default', }) => {
    if (disabled) {
        return CFBaseProgressTokens.COLORS.DISABLED;
    }
    if (alternateTheme) {
        return isCurrent
            ? CFBaseProgressTokens.COLORS.ALTERNATE_CURRENT
            : CFBaseProgressTokens.COLORS.ALTERNATE_DEFAULT;
    }
    if (variant === 'emphasis') {
        return isCurrent
            ? CFBaseProgressTokens.COLORS.EMPHASIS_CURRENT
            : CFBaseProgressTokens.COLORS.EMPHASIS_DEFAULT;
    }
    else if (variant === 'boost') {
        return isCurrent
            ? CFBaseProgressTokens.COLORS.BOOST_CURRENT
            : CFBaseProgressTokens.COLORS.BOOST_DEFAULT;
    }
    return isCurrent
        ? CFBaseProgressTokens.COLORS.CURRENT
        : CFBaseProgressTokens.COLORS.DEFAULT;
};
export const itemWidth = ({ isCurrent = false, shape = 'pills', }) => {
    if (shape === 'dots') {
        return CFBaseProgressTokens.WIDTH.DOT[isCurrent ? 'CURRENT' : 'DEFAULT'];
    }
    else if (shape === 'pills') {
        return CFBaseProgressTokens.WIDTH.PILL[isCurrent ? 'CURRENT' : 'DEFAULT'];
    }
};
